import type {
  ClientType,
  DocumentType,
  ProjectNature,
  ProPrestation,
  Typology,
} from './enums.js';

/** Types de demandeurs du segment professionnels & collectivités. */
export const PRO_CLIENT_TYPES: readonly ClientType[] = [
  'promoteur',
  'amenageur',
  'syndic',
  'sci',
  'entreprise',
  'collectivite',
  'mairie',
  'administration',
  'architecte',
  'bureau_etudes',
];

export const clientTypeLabels: Record<ClientType, string> = {
  particulier: 'Particulier',
  entreprise: 'Entreprise',
  promoteur: 'Promoteur',
  amenageur: 'Aménageur',
  copropriete: 'Copropriété',
  syndic: 'Syndic',
  sci: 'SCI',
  collectivite: 'Collectivité',
  mairie: 'Mairie',
  administration: 'Administration',
  architecte: 'Architecte',
  bureau_etudes: "Bureau d'études",
};

export const projectNatureLabels: Record<ProjectNature, string> = {
  construction_neuve: 'Construction neuve',
  renovation: 'Rénovation',
  rehabilitation: 'Réhabilitation',
  extension: 'Extension',
  division_immobiliere: 'Division immobilière',
  changement_usage: "Changement d'usage",
  mise_en_conformite: 'Mise en conformité',
  autre: 'Autre',
};

export const proPrestationLabels: Record<ProPrestation, string> = {
  previsite_technique: 'Pré-visite technique',
  etude_raccordement: 'Étude de raccordement fibre',
  precablage_telecom: 'Pré-câblage télécom',
  recherche_par: 'Recherche PAR',
  mise_en_conformite_operateur: 'Mise en conformité opérateur',
  chiffrage_travaux: 'Chiffrage des travaux',
  realisation_travaux: 'Réalisation des travaux',
  accompagnement_attestation: "Accompagnement jusqu'à l'attestation de conformité",
};

/** Typologies de projet proposées au segment professionnels & collectivités. */
export const PRO_TYPOLOGIES: readonly Typology[] = [
  'maison_individuelle',
  'villa',
  'immeuble_collectif',
  'lotissement',
  'residence',
  'locaux_pro',
  'commerce',
  'batiment_public',
  'zone_activite',
];

/** Documents demandés au segment professionnels & collectivités. */
export const PRO_REQUIRED_DOCUMENTS: readonly DocumentType[] = [
  'plan_masse',
  'plans_architecte',
  'permis_construire',
  'photo_exterieur',
  'plans_vrd',
  'courrier_operateur',
];

export function isProClientType(type: ClientType | null | undefined): boolean {
  return type != null && PRO_CLIENT_TYPES.includes(type);
}
